<div class="content-renderer">
    @switch (content().type) {
        <!-- Text Content -->
        @case ('text') {
            <div class="text-content">
                @if (content().metadata?.title) {
                    <h4 class="content-title">{{ content().metadata?.title }}</h4>
                }
                <div class="text-body" [ngClass]="{'edit-message': !isBotMessage}">
                    <div class="streaming-container">
                        <span [innerHTML]="formatText(displayedText)"></span>
                        @if (isStreaming) {
                            <span class="typing-cursor">|</span>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- Table Content -->
        @case ('table') {
            <div class="table-content">
                @if (content().metadata?.title) {
                    <div class="table-header">
                        <h4 class="content-title">{{ content().metadata?.title }}</h4>
                        <button class="copy-button" (click)="copyToClipboard(getTableAsText())">
                        </button>
                    </div>
                }

                @if (content().metadata?.description) {
                    <div class="table-description">{{ content().metadata?.description }}</div>
                }

                <div class="table-container">
                    <table class="chat-table">
                        <thead>
                            <tr>
                                @for (header of content().data.headers; track $index) {
                                    <th class="sortable-header"
                                        [attr.aria-sort]="getTableSortAria($index)"
                                        (click)="onTableHeaderSort($index)">
                                        <span class="sortable-header-label">{{ header }}</span>
                                        <span class="sort-indicator">{{ getTableSortIcon($index) }}</span>
                                    </th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of sortedTableRows(); track $index) {
                                <tr>
                                    @for (cell of row; track $index) {
                                        <td>{{ cell }}</td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                @if (content().metadata?.footerText) {
                    <div class="table-footer-text">{{ content().metadata?.footerText }}</div>
                }
            </div>
        }

        <!-- List Content -->
        @case ('list') {
            <div class="list-content">
                @if (content().metadata?.title) {
                    <h4 class="content-title">{{ content().metadata?.title }}</h4>
                }

                @if (content().data?.type === 'unordered') {
                    <ul class="unordered-list">
                        @for (item of content().data?.items; track $index) {
                            <li>
                                <span [innerHTML]="formatText(item)"></span>
                            </li>
                        }
                    </ul>
                }

                @if (content().data?.type === 'ordered') {
                    <ol class="ordered-list">
                        @for (item of content().data?.items; track $index) {
                            <li>
                                <span [innerHTML]="formatText(item)"></span>
                            </li>
                        }
                    </ol>
                }
            </div>
        }

        <!-- Code Content -->
        @case ('code') {
            <div class="code-content">
                <div class="code-header">
                    @if (content().metadata?.title) {
                        <h4 class="content-title">{{ content().metadata?.title }}</h4>
                    }
                    <div class="code-actions">
                        @if (content().metadata?.language) {
                            <span class="language-tag">{{ content().metadata?.language }}</span>
                        }
                        <button class="copy-button" (click)="copyToClipboard(content().data)">
                        </button>
                    </div>
                </div>

                <div class="code-block">
                    <div class="streaming-container">
                        <pre><code [class]="'language-' + (content().metadata?.language || 'text')">{{ displayedText }}@if (isStreaming) {<span class="typing-cursor">|</span>}</code></pre>
                    </div>
                </div>
            </div>
        }

        <!-- Markdown Content -->
        @case ('markdown') {
            <div class="markdown-content">
                @if (content().metadata?.title) {
                    <h4 class="content-title">{{ content().metadata?.title }}</h4>
                }
                <div class="markdown-body">
                    <div class="streaming-container">
                        <span [innerHTML]="formatText(displayedText)"></span>
                        @if (isStreaming) {
                            <span class="typing-cursor">|</span>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- HTML Content -->
        @case ('html') {
            <div class="html-content">
                @if (content().metadata?.title) {
                    <div class="html-header">
                        <h4 class="content-title">{{ content().metadata?.title }}</h4>
                        <button class="copy-button" title="click to copy" (click)="copyToClipboard(content().data)">
                            <span>Copy</span>
                        </button>
                    </div>
                }
                <div class="html-body" [innerHTML]="getSafeHtml(content().data)"></div>
            </div>
        }

        <!-- Mixed Content — ordered sequence of content blocks -->
        @case ('mixed') {
            <div class="mixed-content">
                @for (block of content().data.blocks; track $index) {
                    <app-content-renderer
                        [content]="block"
                        [isBotMessage]="isBotMessage()"
                        [enableStreaming]="false"
                        [streamingSpeed]="streamingSpeed()">
                    </app-content-renderer>
                }
            </div>
        }

        <!-- Chart Content (Highcharts) -->
        @case ('chart') {
            <div class="chart-content">
                @if (content().metadata?.title) {
                    <h4 class="content-title">{{ content().metadata?.title }}</h4>
                }
                <div class="chart-container">
                    <div class="chart-scroll-area" [style.min-width.px]="chartContainerWidth()">
                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="chartOptions()"
                            [style.width.px]="chartContainerWidth()">
                        </highcharts-chart>
                    </div>
                </div>
            </div>
        }

        <!-- Default/Unknown Content -->
        @default {
            <div class="default-content">
                @if (content().metadata?.title) {
                    <h4 class="content-title">{{ content().metadata?.title }}</h4>
                }
                <div class="default-body">
                    <pre>{{ content().data | json }}</pre>
                </div>
            </div>
        }
    }
</div>